








on_clickaway = require('vue-clickaway')

module.exports =
  props: ['value']
  mixins: [ on_clickaway.mixin ]
  data: ->
    colors: Tag.colors
    show_picker: false

  methods:
    setColor: (color) ->
      @$emit('input', color)
      @show_picker = false

    onClickaway: ->
      @show_picker = false



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/color_input.vue